export default __webpack_public_path__ + "static/media/acupuntura.85178891.jpg";